module.exports = __webpack_public_path__ + "static/media/BG.2e8a6ef2.png";